<ng-container *ngIf="!receiptModal && !refundModalPageTwo && !pRefundModalPageTwo && !voidModalPageTwo">
  <hr />
  <!-- SUB TOTAL -->
  <div class="f-18 fw-600 d-flex justify-content-between">
    <div class="mb-1">{{ "Subtotal" | translate | async }}</div>
    <!-- Added Full Refund 0.00 Handling -->
    <div class="mb-1 payment-AED">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (floatnumber(paymentReceipt.orderId.subTotalAmount) | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
  </div>
  <!-- DEVIVERY CHARGES -->
  <div class="f-18 fw-600 d-flex justify-content-between" *ngIf="deliveryFee">
    <div class="mb-1">Delivery Charges</div>
    <div class="mb-1 payment-AED">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (floatnumber(deliveryFee) | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
  </div>
  <!-- PROMO CODE -->
  <div class="f-18 fw-600 d-flex justify-content-between" *ngIf="paymentReceipt.orderId.promoCodeAmount">
    <div class="mb-1">
      {{ "Promo Code" | translate | async }}
      <span *ngIf="paymentReceipt.orderId.promoCode.type !== 1" style="font-size: 14px;" class="fw-lighter">
        ({{ paymentReceipt.orderId.promoCode.name }} @{{ paymentReceipt.orderId.promoCode.value | number : "1.2-2" }}{{ currency }})
      </span>
      <span *ngIf="paymentReceipt.orderId.promoCode.type === 1">
        ({{ paymentReceipt.orderId.promoCode.name }} @{{ paymentReceipt.orderId.promoCode.value }}%)
      </span>
    </div>
    <div class="mb-1">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (floatnumber(paymentReceipt.orderId.promoCodeAmount) | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
  </div>
  <!-- TAX/VAT -->
  <div class="f-18 fw-600 d-flex justify-content-between" *ngIf="paymentReceipt.orderId.taxAmount">
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="paymentReceipt.paymentAmount && taxAliasValue == 'VAT'">
      <div>
        {{ "VAT" | translate | async }}
      </div>
      <div>
        <span style="font-size: 14px;" class="fw-lighter">({{ getTaxNames() | translate | async }})</span>
      </div>
      <!-- @
      {{
        (paymentReceipt.orderId.taxAmount / paymentReceipt.orderId.subTotalAmount) * 100
          | number: "1.2-2"
      }}% -->
    </div>
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="paymentReceipt.paymentAmount && taxAliasValue == 'Tax'">
     <div>
      {{ "Sales Tax" | translate | async }}
     </div>
     <div>
      <span style="font-size: 14px;" class="fw-lighter">({{ getTaxNames() | translate | async }})</span>
     </div>
      <!-- @
      {{
        (paymentReceipt.orderId.taxAmount / paymentReceipt.orderId.subTotalAmount) * 100
          | number: "1.2-2"
      }}% -->
    </div>
    <div class="mb-1 payment-AED" *ngIf="paymentReceipt.paymentAmount && taxAliasValue != 'VAT' && taxAliasValue != 'Tax'">
      {{ (taxAliasValue ? taxAliasValue : 'Sales Tax') | translate | async }} <span style="font-size: 14px;" class="fw-lighter">({{ getTaxNames() | translate | async }})</span>
      <!-- @
      {{
        (paymentReceipt.orderId.taxAmount / paymentReceipt.orderId.subTotalAmount) * 100
          | number: "1.2-2"
      }}% -->
    </div>
    <div class="mb-1  d-flex flex-wrap" style="max-width: 400px;" *ngIf="!paymentReceipt.paymentAmount && taxAliasValue == 'VAT'">
      <div>
        {{ "VAT" | translate | async }}
      </div>
      <div>
        <span style="font-size: 14px;" class="fw-lighter">({{ getTaxNames() }})</span>
      </div>
    </div>
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="!paymentReceipt.paymentAmount && taxAliasValue == 'Tax'">
      <div>
        {{ "Sales Tax" | translate | async }}
      </div>
      <div>
        <span style="font-size: 14px;" class="fw-lighter">({{ getTaxNames() | translate | async }})</span>
      </div>
    </div>
    <div class="mb-1 payment-AED" *ngIf="!paymentReceipt.paymentAmount && taxAliasValue != 'VAT' && taxAliasValue != 'Tax'">
      {{ (taxAliasValue ? taxAliasValue : 'Sales Tax') | translate | async }} <span style="font-size: 14px;" class="fw-lighter">({{ getTaxNames() | translate | async }})</span>
    </div>
    <div class="mb-1 payment-AED">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (paymentReceipt.orderId.taxAmount | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
  </div>
  <!-- SERVICE CHARGES -->
  <div style="color: #000" class="f-18 fw-600 d-flex justify-content-between"
    *ngIf="paymentReceipt.orderId.serviceChargeAmount">
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="paymentReceipt.paymentAmount">
      <div>
        {{ "Service Charges" | translate | async }}
      </div>
      <div>
        <span *ngIf="paymentReceipt.orderId.orderServiceCharge.serviceChargeType !== 1" style="font-size: 14px;"
        class="fw-lighter">
        ({{ paymentReceipt.orderId.orderServiceCharge.serviceChargeName | translate | async }}
        @ {{ currency }}{{ paymentReceipt.orderId.orderServiceCharge.serviceChargeValue | number : "1.2-2" }})
      </span>
      <span *ngIf="paymentReceipt.orderId.orderServiceCharge.serviceChargeType === 1" style="font-size: 14px;"
        class="fw-lighter">
        ({{ paymentReceipt.orderId.orderServiceCharge.serviceChargeName | translate | async }}
        @{{ paymentReceipt.orderId.orderServiceCharge.serviceChargeValue }}%)
      </span>
      </div>
    </div>
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="!paymentReceipt.paymentAmount">
      <div>
        {{ "Service Charges" | translate | async }}
      </div>
      <div>
        <span *ngIf="paymentReceipt.orderId.orderServiceCharge.serviceChargeType !== 1" style="font-size: 14px;"
        class="fw-lighter">
        ({{ paymentReceipt.orderId.orderServiceCharge.serviceChargeName }}
        @ {{ currency }}{{ paymentReceipt.orderId.orderServiceCharge.serviceChargeValue | number : "1.2-2" }})
      </span>
      <span *ngIf="paymentReceipt.orderId.orderServiceCharge.serviceChargeType === 1" style="font-size: 14px;"
        class="fw-lighter">
        ({{ paymentReceipt.orderId.orderServiceCharge.serviceChargeName }}
        @ {{ paymentReceipt.orderId.orderServiceCharge.serviceChargeValue }}%)
      </span>
      </div>
    </div>
    <div class="mb-1 payment-AED">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (floatnumber(paymentReceipt.orderId.serviceChargeAmount) | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
  </div>
  <!-- DISCOUNT -->
  <div class="f-18 fw-600 d-flex justify-content-between" *ngIf="paymentReceipt.orderId.discountAmount">
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="paymentReceipt.paymentAmount">
      <!-- class="discount-width" -->
      <div>
        {{ "Discount" | translate | async }}
      </div>
      <!-- class="discount-width" -->
     <div>
      <!-- discount-width -->
      <span style="font-size: 14px;" class="fw-lighter" *ngIf="_getDiscountNames" [innerHTML]="_getDiscountNames"></span>
      <!-- discount-width -->
      <span *ngIf="paymentReceipt.orderId.globalDiscount.discountType !== 1" style="font-size: 14px;"
        class="fw-lighter">
        <ng-container *ngIf="paymentReceipt.orderId.globalDiscount?.discountName && paymentReceipt.orderId.globalDiscount.discountValue">
          ({{ paymentReceipt.orderId.globalDiscount?.discountName | translate | async }}
          @ {{ currency }}{{ paymentReceipt.orderId.globalDiscount.discountValue | number : "1.2-2" }})
        </ng-container>
      </span>
      <!-- discount-width -->
      <span *ngIf="paymentReceipt.orderId.globalDiscount.discountType === 1" style="font-size: 14px;"
        class="fw-lighter">
        <ng-container *ngIf="paymentReceipt.orderId.globalDiscount?.discountName && paymentReceipt.orderId.globalDiscount.discountValue">
          ({{ paymentReceipt.orderId.globalDiscount?.discountName | translate | async }}
          @{{ paymentReceipt.orderId.globalDiscount.discountValue }}%)
        </ng-container>
      </span>
     </div>
    </div>
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;"*ngIf="!paymentReceipt.paymentAmount">
      <!-- class="discount-width" -->
      <div>
        {{ "Discount" | translate | async }}
      </div>
      <!-- class="discount-width" -->
      <div>
        <!--  discount-width -->
        <span style="font-size: 14px;" class="fw-lighter" *ngIf="_getDiscountNames" [innerHTML]="(_getDiscountNames | translate | async)"></span>
        <!-- discount-width" -->
        <span *ngIf="paymentReceipt.orderId.globalDiscount.discountType !== 1" style="font-size: 14px;"
          class="fw-lighter">
          <ng-container *ngIf="paymentReceipt.orderId.globalDiscount?.discountName && paymentReceipt.orderId.globalDiscount.discountValue">
            ({{ paymentReceipt.orderId.globalDiscount?.discountName | translate | async }}
            @ {{ currency }} {{ paymentReceipt.orderId.globalDiscount.discountValue | number : "1.2-2" }})
          </ng-container>
        </span>
        <!--  discount-width" -->
        <span *ngIf="paymentReceipt.orderId.globalDiscount.discountType === 1" style="font-size: 14px;"
          class="fw-lighter">
          <ng-container *ngIf="paymentReceipt.orderId.globalDiscount?.discountName && paymentReceipt.orderId.globalDiscount.discountValue">
            ({{ paymentReceipt.orderId.globalDiscount?.discountName | translate | async }}
            @{{ paymentReceipt.orderId.globalDiscount.discountValue }}%)
          </ng-container>
        </span>
      </div>
    </div>
    <div class="d-flex gap-2">
      <!-- <div class="mb-1 payment-AED">
        {{ paymentReceipt.orderId.discountAmount | currency: currency: 'symbol':'1.2-2' }}
      </div> -->
      <div class="mb-1 payment-AED">
        {{
          paymentReceipt.orderId.orderSellStatus === 6
            ? (0 | currency: currency: 'symbol':'1.2-2')
            : (paymentReceipt.orderId.discountAmount | currency: currency: 'symbol':'1.2-2')
        }}
      </div>
    </div>
  </div>
  <!-- TIPS -->
  <div class="f-18 fw-600 d-flex justify-content-between mb-3" *ngIf="paymentReceipt.paymentTipAmount">
    <div class="mb-1 tips-payment">{{ "Tips" | translate | async }}</div>
   <div class="d-flex gap-2">
    <!-- <div class="mb-1 payment-AED">
      {{ paymentReceipt.paymentTipAmount | currency: currency: 'symbol':'1.2-2' }}
    </div> -->
    <div class="mb-1 payment-AED">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (paymentReceipt.paymentTipAmount | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
   </div>
  </div>
  <!-- TOTAL AMOUNT -->
  <div class="f-24 fw-700 d-flex justify-content-between mb-3" *ngIf="paymentReceipt">
    <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;" *ngIf="!refundModalPageOne && !voidModalPageOne">
      <div class="tips-payment">
        {{ "Total Amount" | translate | async }}
      </div>
      <div>
        <span *ngIf="paymentReceipt.orderId.orderSellStatus == 8" style="font-size: 14px;"
        class="fw-lighter">({{ "Custom Refund" | translate | async }} {{ getCustomRefundAmount() | currency: currency: 'symbol':'1.2-2' }})</span>
      </div>
    </div>
    <div class="mb-1" *ngIf="refundModalPageOne">{{ "Total Refund Amount" | translate | async }}</div>
    <!-- <div class="mb-1" *ngIf="!voidModalPageOne">Total Amount</div> -->
    <div class="mb-1" *ngIf="voidModalPageOne">{{ "Total Void Amount" | translate | async }}</div>
    <div class="mb-1 payment-total-amount">
      {{
        paymentReceipt.orderId.orderSellStatus === 6
          ? (0 | currency: currency: 'symbol':'1.2-2')
          : (paymentReceipt.paymentAmount | currency: currency: 'symbol':'1.2-2')
      }}
    </div>
  </div>
</ng-container>
<div class="row order-refund" *ngIf="
    !receiptModal &&
    !refundModalPageOne &&
    !voidModalPageOne &&
    !refundModalPageTwo &&
    !voidModalPageTwo &&
    !pRefundModalPageOne &&
    !pRefundModalPageTwo &&
    !cRefundModalPageOne &&
    !cRefundModalPageTwo &&
    storedItem?.permissionValue == 3
  ">
  <div class="col-sm-6 mb-3">
    <button class="w-100 btn w-100 f-18 fw-600 grey_btn_theme text-uppercase"
      [disabled]="partialRefundCheck(paymentReceipt)" (click)="partialRefundFunc(paymentReceipt)">
      {{ "Partial Refund" | translate | async }}
    </button>
  </div>
  <div class="col-sm-6 mb-3">
    <button class="w-100 btn w-100 f-18 fw-600 grey_btn_theme text-uppercase"
      [disabled]="partialRefundCheck(paymentReceipt)" (click)="customRefundFunc(paymentReceipt)">
      {{ "Custom Refund" | translate | async }}
    </button>
  </div>
  <div class="col-sm-6 mb-3">
    <button class="w-100 btn w-100 f-18 fw-600 grey_btn_theme text-uppercase"
      [disabled]="checkFullRefund(paymentReceipt)" (click)="fullRefundFunc(paymentReceipt)">
      {{ "Full Refund" | translate | async }}
    </button>
  </div>
  <div class="col-sm-6 mb-3">
    <button class="w-100 btn w-100 f-18 fw-600 grey_btn_theme text-uppercase" *ngIf="!editOrderLoader"
      (click)="editOrderFunc(paymentReceipt)" [disabled]="editOrderCheck(paymentReceipt) || editOrderLoader">
      {{ "Edit Order" | translate | async }}
    </button>
    <button class="w-100 btn w-100 f-18 fw-600 btn-grey" *ngIf="editOrderLoader" disabled>
      {{ "Please Wait..." | translate | async }}
    </button>
  </div>
  <div *ngIf="isVoidTransaction && checkingComponent == 'transactions'" class="col-sm-6 mb-3">
    <!-- [disabled]="checkFullRefund(paymentReceipt)" -->
    <button *ngIf="!voidOrderLoader" class="w-100 btn w-100 f-18 fw-600 grey_btn_theme text-uppercase"
      [disabled]="checkVoidPayment(paymentReceipt)" (click)="voidOrderFunc(paymentReceipt)">
      {{ "Void" | translate | async }}
    </button>
    <button class="w-100 btn w-100 f-18 fw-600 btn-grey" *ngIf="voidOrderLoader" disabled>
      {{ "Please Wait..." | translate | async }}
    </button>
  </div>

  <div class="col-sm-6 mb-3">
    <button class="w-100 btn w-100 f-14 fw-600 btn-grey" disabled *ngIf="closeOrderLoader">
      {{ "Please wait..." | translate | async }}
    </button>
    <button class="w-100 btn w-100 f-18 fw-600 close_btn_theme text-uppercase" *ngIf="!closeOrderLoader"
      [disabled]="checkCloseOrder(paymentReceipt)" (click)="closeOrderFunc(paymentReceipt)">
      {{ "Close Order" | translate | async }}
    </button>
  </div>
  <div class="col-sm-6 mb-3 send-receipt">
    <button accessControl module="SalesTransaction" access="3"
      class="w-100 btn w-100 f-18 fw-600 grey_btn_theme text-uppercase" [disabled]="checkSendReceipt(paymentReceipt)"
      (click)="sendReceiptFunc(paymentReceipt)">
      {{ "Send Receipt" | translate | async }}
    </button>
  </div>
</div>
<div class="row">
  <ng-container *ngIf="refundModalPageOne || voidModalPageOne || pRefundModalPageOne || cRefundModalPageOne">
    <div class="col-6 mb-3"></div>
    <div class="col-6 mb-3" *ngIf="refundModalPageOne">
      <button class="w-100 w-100 f-14 fw-600 bg-gray red-btn-theme text-uppercase"
        [disabled]="checkSendReceipt(paymentReceipt)" (click)="goToRefundPageTwoFunc()">
        {{ "Select a Reason" | translate | async }}
      </button>
    </div>
    <div class="col-6 mb-3" *ngIf="voidModalPageOne">
      <button class="w-100 w-100 f-14 fw-600 bg-gray red-btn-theme text-uppercase"
        [disabled]="checkSendReceipt(paymentReceipt)" (click)="goToVoidPageTwoFunc()">
        {{ "Select a Reason" | translate | async }}
      </button>
    </div>
    <div class="col-6 mb-3" *ngIf="pRefundModalPageOne">
      <button class="w-100 reason-btn w-100 f-14 fw-600 bg-gray" [disabled]="
          checkSendReceipt(paymentReceipt) ||
          (refundPartialItems && refundPartialItems.length === 0)
        " (click)="goToPRefundPageTwoFunc()">
        {{ "Select a Reason" | translate | async }}
      </button>
    </div>
    <div class="col-6 mb-3" *ngIf="cRefundModalPageOne">
      <button class="w-100 reason-btn w-100 f-14 fw-600 bg-gray text-uppercase"
        [disabled]="checkSendReceipt(paymentReceipt) || totalCustomRefund === 0.00 || disableReasonBtn"
        (click)="goToCRefundPageTwoFunc()">
        {{ "Select a Reason" | translate | async }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="refundModalPageTwo">
    <!-- <span class="text-danger f-w-5">{{ fullRefundErrMsg }}</span> -->
    <div class="col-6 mb-3"></div>
    <div class="col-6 mb-3">
      <button class="w-100 btn w-100 f-14 fw-600 bg-gray red-btn-theme" [disabled]="checkSendReceipt(paymentReceipt)"
        (click)="fullPaymentRefundFunc(paymentReceipt)" [disabled]="refundReason == ''">
        {{ "REFUND -" | translate | async }} {{ globalAmount | currency: currency: 'symbol':'1.2-2' }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="voidModalPageTwo">
    <div class="col-6 mb-3"></div>
    <div class="col-6 mb-3">
      <button class="w-100 btn w-100 f-14 fw-600 bg-gray red-btn-theme" [disabled]="checkSendReceipt(paymentReceipt)"
        (click)="voidPaymentFunc(paymentReceipt)" [disabled]="refundReason == ''">
        {{ "VOID -" | translate | async }} {{ globalAmount | currency: currency: 'symbol':'1.2-2' }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="pRefundModalPageTwo">
    <div class="col-6 mb-3"></div>
    <div class="col-6 mb-3">
      <button class="w-100 btn w-100 f-14 fw-600 bg-gray text-uppercase" [disabled]="checkSendReceipt(paymentReceipt)"
        (click)="partialPaymentRefundFunc(paymentReceipt)" [disabled]="refundReason == ''">
        {{ "Refund -" | translate | async }} {{ totalPartialRefund | currency: currency: 'symbol':'1.2-2' }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="cRefundModalPageTwo">
    <div class="col-6 mb-3"></div>
    <div class="col-6 mb-3">
      <button class="w-100 btn w-100 f-14 fw-600 bg-gray text-uppercase" [disabled]="checkSendReceipt(paymentReceipt)"
        (click)="customPaymentRefundFunc(paymentReceipt)" [disabled]="refundReason == ''">
        {{ "Refund -" | translate | async }} {{ totalCustomRefund | currency: currency: 'symbol':'1.2-2' }}
      </button>
    </div>
  </ng-container>
</div>
